export class UnAssignActionModel {

    action: string;
    licenseClientId: string;

}
